import React, { useState, useRef, useContext, useEffect } from 'react';
import { defineMessages } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import withInnerRef from 'lib/react/with-inner-ref';
import Localizable from 'lib/intl/localizable';
import withDialog from 'lib/alerts/with-dialog';
import CropperView from 'lib/ui/cropper-view';
import { InfoDialog } from 'lib/alerts/dialog';
import { imageDataURL } from 'lib/utils/dom';

import { FourNetsStackViewContent } from 'four-nets/ui/four-nets-stack-view-content/four-nets-stack-view-content';
import Modal from 'four-nets/ui-v2/modal/modal';
import { AlertContext } from 'lib/alert-context/alert-context';

interface Props {
    open?: boolean;
    file?: File | null;
    onClose: () => any;
    onAction: (blob: Blob) => any;
}

const AvatarCropperStackView: React.FC<Props> = props => {
    const cropperView = useRef<any>(null);
    const [src, setSrc] = useState(null);
    const { fail } = useContext(AlertContext);
    const { open, file } = props;

    const setCropperView = (ref: any) => {
        cropperView.current = ref;
    };

    const crop = () => {
        if (cropperView.current) {
            cropperView.current.cropper.getCroppedCanvas().toBlob(props.onAction);
            props.onClose();
        }
    };

    const onAction = () => {
        const canvas = document.createElement('canvas');
        if (!canvas.toBlob) {
            import('blueimp-canvas-to-blob').then(crop).catch(err => {
                fail({
                    body: <FormattedMessage id='FAILED_TO_PROCESS_IMAGE' />,
                    onAccept: () => {
                        /* pass */
                    },
                });
            });
        } else {
            crop();
        }
    };

    useEffect(() => {
        if (file) {
            imageDataURL({ file, maxWidth: 800 }).then(result => {
                setSrc(result);
            });
        } else {
            setSrc(null);
        }
    }, [file]);

    return (
        <Modal title={<FormattedMessage id='EDIT_IMAGE' />} open={!!open} onClose={props.onClose} onAccept={onAction}>
            <CropperView src={src} aspectRatio={1} ref={setCropperView} />
        </Modal>
    );
};

export default AvatarCropperStackView;
